import React from "react";
import CommonDataTable from "../../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../../components/buttons/ButtonRounded";
import CommonDropdown from "../../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../../components/dropdown/DropdownButton";
import Moment from "react-moment";
import Badge from "../../../../components/Common/Badge/Badge";
import { AppContext } from "../../../../contexts/AppContext";
import CommonsHelper from "../../../../helpers/CommonsHelper";
import CommonSwal from "../../../../components/Swal/commonSwal";
import { formataData } from "../../../../helpers/mesesHelper";
import { FaPlus } from "react-icons/fa6";
import Format from "../../../../helpers/Format";
import PropTypes from "prop-types";

function ImpostosDataTable({
  linhas,
  togNovoImpostoModal,
  visualizarDocumento,
  togPagarImpostoModal,
  excluirImposto,
  togSubstituirImpostoModal,
  togSolicitarRecalculoModal,
  cancelarRecalculo,
  toghistoricoModal,
  downloadDocumento,
  noButton = false,
}) {
  const { session } = React.useContext(AppContext);
  const isMobile = CommonsHelper.isMobile();

  const colunas = React.useMemo(
    () => [
      {
        Header: "Descrição",
        accessor: "descricao",
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="col">
            <div>{row.original.descricao}</div>
            <div>
              <strong>
                <pre>{row.original.categoria}</pre>
              </strong>
            </div>
          </div>
        ),
      },
      {
        Header: "Vencimento",
        disableSortBy: true,
        accessor: (row) => {
          return formataData(row.data_vencimento);
        },
      },
      {
        Header: "Valor",
        accessor: (row) => {
          return Format.formataValor(row.valor ?? 0);
        },
        disableSortBy: true,
      },
      {
        Header: "Status",
        accessor: "categoria",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];
          var data_vencimento = new Date(row.original.data_vencimento);
          var dia_atual = new Date();
          data_vencimento.setDate(data_vencimento.getDate() + 1);
          const historico = JSON.parse(row.original.historico);
          let documentos;
          if (historico !== null) documentos = JSON.parse(historico.documentos);

          if (row.original.data_pago == null) {
            if (dia_atual < data_vencimento) {
              status.push(
                <div>
                  <Badge color="warning">Pendente</Badge>
                </div>
              );
            } else {
              status.push(
                <div>
                  <Badge color="danger">Vencido</Badge>
                </div>
              );
            }
          }

          if (row.original.valor_pago) {
            status.push(
              <div>
                <Badge color="success">
                  Pago {Format.formataValor(row.original.valor_pago)} em{" "}
                  {
                    <Moment format="DD/MM/YYYY">
                      {row.original.data_pago}
                    </Moment>
                  }
                </Badge>
              </div>
            );
          }

          if (Array.isArray(documentos) && documentos.length > 1) {
            status.push(
              <div>
                <Badge color="info">
                  Substituído em:{" "}
                  {
                    <Moment format="DD/MM/YYYY">
                      {documentos[documentos.length - 1].data_upload}
                    </Moment>
                  }
                </Badge>
              </div>
            );
          } else {
            status.push(
              <div>
                <Badge color="info">
                  Enviado em:{" "}
                  {
                    <Moment format="DD/MM/YYYY">
                      {row.original.created_at}
                    </Moment>
                  }
                </Badge>
              </div>
            );
          }

          if (row.original.data_visualizado) {
            status.push(
              <div>
                <Badge color="info">
                  Visualizado em:{" "}
                  {
                    <Moment format="DD/MM/YYYY">
                      {row.original.data_visualizado}
                    </Moment>
                  }
                </Badge>
              </div>
            );
          } else if (row.original.status_view === "VISUALIZADO") {
            status.push(
              <div>
                <Badge color="info">Visualizado</Badge>
              </div>
            );
          }

          if (row.original.status_view === "SOLICITADO_RECALCULO") {
            status.push(
              <div>
                <Badge color="warning">Recálculo solicitado</Badge>
              </div>
            );
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];
          var data_vencimento = new Date(row.original.data_vencimento);
          data_vencimento.setDate(data_vencimento.getDate() + 1);
          var dia_atual = new Date();

          const historico = JSON.parse(row.original.historico);
          let documentos;
          if (historico !== null) documentos = JSON.parse(historico.documentos);

          status.push(
            <>
              <DropdownButton
                key={`download-${row.original.uid}`}
                onClick={() => {
                  downloadDocumento(
                    row.original.caminho,
                    Format.removeCaracteresInvalidos(row.original.caminho),
                    true,
                    row.original.uid,
                    row.original.status_view
                  );
                }}
                color="success"
                icon="mdi mdi-cloud-download"
              >
                Download
              </DropdownButton>
            </>
          );

          if (!isMobile)
            status.push(
              <DropdownButton
                key={`visualizar-${row.original.uid}`}
                onClick={() => {
                  visualizarDocumento(
                    row.original.caminho,
                  );
                }}
                color="primary"
                icon="mdi mdi-file-search"
              >
                Visualizar
              </DropdownButton>
            );

          if (row.original.status_view !== "SOLICITADO_RECALCULO")
            status.push(
              <DropdownButton
                key={`pagamento-${row.original.uid}`}
                onClick={() => {
                  togPagarImpostoModal(
                    row.original.uid,
                    !!row.original.valor_pago,
                    row.original.valor
                  );
                }}
                color="warning"
                icon="mdi mdi-cash-check"
              >
                {row.original.valor_pago
                  ? "Cancelar pagamento"
                  : "Informar pagamento"}
              </DropdownButton>
            );

          if (parseInt(session?.codigo) >= 10)
            status.push(
              <DropdownButton
                key={`excluir-${row.original.uid}`}
                onClick={() => {
                  excluirImposto(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir
              </DropdownButton>
            );

          if (row.original.codigo_barras)
            status.push(
              <DropdownButton
                key={`copiar-codigo-${row.original.uid}`}
                onClick={() => {
                  CommonsHelper.copiarConteudo(row.original.codigo_barras).then(
                    () => {
                      CommonSwal({
                        title: "Código de barras copiado",
                        icon: "success",
                      });
                    }
                  );
                }}
                color="secondary"
                icon="mdi mdi-barcode"
              >
                Copiar código de barras
              </DropdownButton>
            );

          if (
            dia_atual >= data_vencimento &&
            row.original.status_view !== "SOLICITADO_RECALCULO" &&
            row.original.valor_pago == null
          )
            status.push(
              <DropdownButton
                key={`solicitar-recalculo-${row.original.uid}`}
                onClick={() => {
                  togSolicitarRecalculoModal(
                    row.original.uid,
                    row.original.categoria,
                    row.original.mes_referencia
                  );
                }}
                color="info"
                icon="mdi mdi-redo-variant"
              >
                Solicitar recálculo
              </DropdownButton>
            );

          if (parseInt(session?.codigo) === 99) {
            status.push(<div className="dropdown-divider"></div>);
            if (row.original.status_view === "SOLICITADO_RECALCULO") {
              status.push(
                <DropdownButton
                  key={`cancelar-recalculo-${row.original.uid}`}
                  onClick={() => {
                    cancelarRecalculo(row.original.uid);
                  }}
                  color="danger"
                  icon="mdi mdi-book-cancel"
                >
                  Cancelar solicitação de recálculo
                </DropdownButton>
              );
            }
            status.push(
              <DropdownButton
                key={`substituir-${row.original.uid}`}
                onClick={() => {
                  togSubstituirImpostoModal(row.original.uid);
                }}
                color="info"
                icon="mdi mdi-file-replace"
              >
                Substituir
              </DropdownButton>
            );
          }

          if (Array.isArray(documentos) && documentos.length > 1)
            status.push(
              <DropdownButton
                key={`historico-${row.original.uid}`}
                onClick={() => {
                  toghistoricoModal(
                    historico,
                    documentos,
                    row.original.descricao,
                    row.original.categoria,
                    row.original.uid
                  );
                }}
                color="info"
                icon="mdi mdi-history"
              >
                Histórico
              </DropdownButton>
            );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      cancelarRecalculo,
      downloadDocumento,
      excluirImposto,
      isMobile,
      session?.codigo,
      togPagarImpostoModal,
      togSolicitarRecalculoModal,
      togSubstituirImpostoModal,
      toghistoricoModal,
      visualizarDocumento,
    ]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        noButton || parseInt(session?.codigo) !== 99 ? null : (
          <ButtonRounded
            onClick={() => {
              togNovoImpostoModal();
            }}
            color="success"
            icon={<FaPlus />}
          >
            Novo imposto
          </ButtonRounded>
        )
      }
    />
  );
}

ImpostosDataTable.propTypes = {
  linhas: PropTypes.array.isRequired,
  togNovoImpostoModal: PropTypes.func.isRequired,
  visualizarDocumento: PropTypes.func.isRequired,
  togPagarImpostoModal: PropTypes.func.isRequired,
  excluirImposto: PropTypes.func.isRequired,
  togSubstituirImpostoModal: PropTypes.func.isRequired,
  togSolicitarRecalculoModal: PropTypes.func.isRequired,
  cancelarRecalculo: PropTypes.func.isRequired,
  toghistoricoModal: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  noButton: PropTypes.bool,
  row: PropTypes.object,
};

export default ImpostosDataTable;
